<template>
    <div>
        <a :href="downloadUrl" class="btn btn-primary">
            <span class="fa fa-download"></span>
            Download Original
        </a>

        <button v-if="canEdit" class="btn btn-default" :disabled="!canReparse" @click="reparse">
            <span class="fa fa-refresh" :class="{ 'fa-spin': !canReparse }"></span>
            Re-parse
        </button>

        <hr />

        <table style="width: 100%;" v-if="inventory">
            <tr>
                <td><strong>Status</strong></td>
                <td class="text-right"><inventory-status :inventory="inventory"></inventory-status></td>
            </tr>
            <tr v-if="inventory.status == 'parsing' || inventory.status == 'matching'">
                <td colspan="2">
                    <div class="progress progress-darker sm">
                        <div class="progress-bar progress-bar-striped active" :style="{ width: inventory.progress+'%' }"></div>
                    </div>
                </td>
            </tr>
            <tr>
                <td><strong>Items</strong></td>
                <td class="text-right">{{ inventory.items_count || 0 | numberFormat }}</td>
            </tr>
            <tr v-if="inventory.info && inventory.info.totalRows">
                <td><strong>Spreadsheet Rows</strong></td>
                <td class="text-right">{{ inventory.info.totalRows | numberFormat }}</td>
            </tr>
            <tr v-if="inventory.info && inventory.info.parsingTime">
                <td><strong>Parsing Time</strong></td>
                <td class="text-right">{{ inventory.info.parsingTime | numberFormat(2) }}s</td>
            </tr>
        </table>

        <div v-if="inventory && inventory.info && inventory.info.columns">
            <hr />

            <table class="table table-condensed">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Column</th>
                        <th>Title</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(options, key) in inventory.info.columns">
                        <td>{{ key }}</td>
                        <td>
                            <div v-if="options.foundColumn">
                                {{ options.columnLetter }}
                            </div>
                            <div v-else>
                                <em>Not found</em>
                            </div>
                        </td>
                        <td>
                            <div v-if="options.foundColumn">
                                {{ options.columnTitle }}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="inventory && inventory.messages && inventory.messages.length">
            <hr />

            <div v-for="message in inventory.messages">
                <p v-if="message.type == 'warning'" class="text-yellow">
                    <span class="fa fa-exclamation-circle"></span>
                    {{ message.message }}
                </p>
                <p v-if="message.type == 'error'" class="text-red">
                    <span class="fa fa-times-circle"></span>
                    {{ message.message }}
                </p>
                <p v-if="message.type != 'warning' && message.type != 'error'">
                    {{ message.message }}
                </p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
        },
        props: ['inventoryId', 'downloadUrl', 'reparseUrl', 'canEdit'],
        data() {
            return {
                inventory: null,
            }
        },
        computed: {
            canReparse() {
                if (!this.inventory)
                    return false;

                switch (this.inventory.status) {
                    case 'ready':
                    case 'error':
                        return true;
                }

                return false;
            }
        },
        methods: {
            updateInventory(inventory) {
                this.inventory = inventory;
            },
            reparse() {
                this.inventory.status = 'queued';
                this.inventory.progress = 0;
                axios.post(this.reparseUrl);
            },
        },
    }
</script>
